const IFRAME_ID = 'iframe_prescription'

function getStylesheetTags(): string {
  return Array.from(document.querySelectorAll<HTMLLinkElement>('head link[rel="stylesheet"]'))
    .map((link) => `<link rel="stylesheet" media="all" href="${link.href}">`)
    .join('')
}

function getPrintFrame(): HTMLIFrameElement {
  const existing = document.getElementById(IFRAME_ID)
  if (existing instanceof HTMLIFrameElement) {
    return existing
  }
  const iframe = document.createElement('iframe')
  iframe.id = IFRAME_ID
  iframe.width = '900'
  iframe.height = '800'
  iframe.hidden = true
  iframe.setAttribute('sandbox', 'allow-same-origin allow-modals')
  document.body.appendChild(iframe)
  return iframe
}

/** Prints `body` from a hidden iframe carrying the page's stylesheets, as the legacy print_treatment did. */
export function printHtml(body: string): void {
  const iframe = getPrintFrame()
  const document_ = iframe.contentDocument
  if (!document_) {
    return
  }
  document_.open()
  document_.write(`<html><head>${getStylesheetTags()}</head><body>${body}</body></html>`)
  document_.close()
  window.setTimeout(() => iframe.contentWindow?.print(), 500)
}
